// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__DVi57","form":"EditListingDescriptionPanel_form__3F8zn","title":"EditListingDescriptionPanel_title__3jq6T"};